var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"d-lg-none",attrs:{"dark":"","color":"#151515"}},[_c('v-app-bar-nav-icon',{on:{"click":_vm.showNavigation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }